"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsComponent = void 0;
/* eslint-disable @typescript-eslint/no-var-requires */
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
// import { browserName } from 'react-device-detect';
var react_device_detect_1 = require("react-device-detect");
require("./NewsComponent.scss");
var config_1 = require("@app/shared/config");
// import Log from '@app/shared/log';
var blastLogo = require('@static/blast-logo.png');
/**
 * TODO: Display latest news or site updates?
 */
var NewsComponent = function () {
    // Log.info(`BROWSER INFO: ${browserName}\nIS CHROME: ${isChrome}\nIS CHROMIUM: ${isChromium}\nIS EDGE: ${isEdge}\nIS EDGE CHROMIUM: ${isEdgeChromium}\nIS FIREFOX: ${isFirefox}\nIS SAFARI: ${isSafari}`);
    var isTradBrowser = react_device_detect_1.isChrome || react_device_detect_1.isChromium || react_device_detect_1.isEdge || react_device_detect_1.isEdgeChromium || react_device_detect_1.isFirefox || react_device_detect_1.isSafari;
    return (react_1.default.createElement("div", { className: "news-component" },
        react_1.default.createElement("div", { className: "blast-logo" },
            react_1.default.createElement("img", { src: blastLogo.default, alt: "Blast Logo" })),
        react_1.default.createElement("div", { className: "content news-component-content is-hidden-mobile" },
            react_1.default.createElement("h1", { className: "is-size-3 has-text-weight-bold" }, "Welcome to Blast!"),
            react_1.default.createElement("p", null, "Hasbro\u2019s approved way to securely transfer large files."),
            react_1.default.createElement("p", { className: "has-text-weight-bold" },
                "Enjoy the journey! ",
                react_1.default.createElement("span", { className: "icon" },
                    react_1.default.createElement("i", { className: "fas fa-rocket" }))),
            react_1.default.createElement("p", null,
                react_1.default.createElement("a", { href: "mailto:" + config_1.Config.CONTACT_EMAIL }, config_1.Config.CONTACT_EMAIL))),
        react_1.default.createElement("div", { className: classnames_1.default('disclaimer is-hidden-mobile', { 'is-hidden': isTradBrowser }) },
            react_1.default.createElement("p", null, "Blast works optimally on Chrome, Firefox, Safari, and Microsoft Edge. Your experience may be affected if you are using a different internet browser."))));
};
exports.NewsComponent = NewsComponent;
